<template>
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <el-tabs v-if="userType == 3&&!show" v-model="activeName" class="el-tab_top">
          <el-tab-pane label="作物生长模型" name="first">
            <growthModelManagement></growthModelManagement>
          </el-tab-pane>
          <el-tab-pane label="作物肥料模型" name="three">
            <growthModelFertilizer></growthModelFertilizer>
          </el-tab-pane>

        </el-tabs>
        <!-- <el-tab-pane label="大棚环境模型" name="second">
          </el-tab-pane> -->
        <!-- <el-tab-pane label="大棚调控设备" name="six" v-if="userType != 3&&!show">
            <growthModelDeviceControlManagement></growthModelDeviceControlManagement>
          </el-tab-pane>
          <el-tab-pane label="大棚告警配置" name="four" v-if="userType != 3&&!show">
            <groupAlarmManagement></groupAlarmManagement>
          </el-tab-pane>
          <el-tab-pane label="大棚告警记录" name="five" v-if="userType != 3&&!show">
            <groupAlarmHisAlarm></groupAlarmHisAlarm>
          </el-tab-pane> -->
        <!-- <el-tab-pane label="农事记录" name="seven" v-if="show">
            <groupFarm></groupFarm>
          </el-tab-pane> -->
        <growthModelEvnManagement v-if="userType != 3&&!show"></growthModelEvnManagement>

        <groupFarm v-if="show"></groupFarm>
      </div>
    </div>
  </div>
</template>
<script>
import growthModelFertilizer from '../growthModelManagement/growthModelFertilizer'
import growthModelManagement from '../growthModelManagement/growthModelManagement'
import growthModelEvnManagement from '../growthModelManagement/growthModelEvnManagement'
import planManagement from '../photosynthesis/planManagement'
import groupAlarmManagement from '../groupAlarm/groupAlarmManagement'
import groupAlarmHisAlarm from '../groupAlarm/groupAlarmHisAlarm'
import groupFarm from '../groupAlarm/groupFarm'
import growthModelDeviceControlManagement from '../growthModelManagement/growthModelDeviceControlManagement'

export default {
  components: {
    growthModelManagement,
    growthModelEvnManagement,
    planManagement,
    groupAlarmManagement,
    groupAlarmHisAlarm,
    growthModelDeviceControlManagement,
    groupFarm,
    growthModelFertilizer
  },
  data() {
    return {
      activeName: 'first',
      userType: 0, // 用户类型（-1 超级管理员，0管理员，1测试用户，2普通用户，3专家用户）
      show: false
    }
  },
  created() {
    this.userType = sessionStorage.getItem('USER_Type')

    if (this.userType == 3) {
      this.activeName = 'first'
    } else {
      if (this.$route.query.currentShow) {
        this.activeName = this.$route.query.currentShow

      } else {
        this.activeName = 'second'
      }
    }
    if (this.$route.query.activeName) {
      if (this.$route.query.activeName == 'seven') {
        this.show = true
      } else {
        this.show = false
      }

      this.activeName = this.$route.query.activeName
    }
    if (this.$route.query.currentShow) {
      this.activeName = this.$route.query.currentShow
    }
    console.log(this.activeName);

  },
  methods: {
    handleSelect() { }
  }
}
</script>
<style scoped>
@import '../../style/userManagement.scss';
</style>